import { SettingsItem } from '../SettingsLayout/SettingsLayout'
import UpgradeRequestForm from '../UpgradeRequestForm/UpgradeRequestForm'
import useUserData from '../../hooks/useUserData'

// A limited user with no real organisation messages Support to be connected to one. First Organisation setting: it takes priority.
function ConnectOrganisationSetting() {
	const userData = useUserData()

	if (!userData.canRequestUpgrade) {
		return null
	}

	return (
		<SettingsItem
			title='Connect a real organisation'
			description='Your account has not yet been connected to a real organisation. To set one up, please contact our Support Team using this form:'
		>
			<UpgradeRequestForm
				idPrefix='support-request'
				kind='support'
				reasonLabel='Message to Support'
				reasonPlaceholder='Your message'
				requireReason
				submitText='Send to Support'
				pendingText='Your message has been sent. The Neoni team will be in touch. You can send another message above.'
			/>
		</SettingsItem>
	)
}

export default ConnectOrganisationSetting
